import React, { useMemo } from 'react';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import ButtonTooltip from '@mui/material/Tooltip';
import { getActiveMarker, getSelectedVars, getHighlightedItem } from '../../state/selectors';
import useStyles from '../../styles';
import { VarName, varNameDetails } from '../../utils/varNames';
import { setActiveMarker, setClickedItem, setHighlightedItem } from '../../state/actions';
import SourcesMenu from '../../components/SourcesMenu';
import { useAppDispatch, useAppSelector } from '../../state/store';

function SourceToolbar(): JSX.Element {
  const { classes } = useStyles();
  const selectedVars = useAppSelector(getSelectedVars);
  const dispatch = useAppDispatch();
  const activeMarker = useAppSelector(getActiveMarker);
  const highlightedItem = useAppSelector(getHighlightedItem);

  const activeVarname = useMemo(() => {
    let activeSource: VarName = activeMarker;
    if (highlightedItem.id !== '' && highlightedItem.varName)
      activeSource = highlightedItem.varName;
    return activeSource;
  }, [highlightedItem, activeMarker]);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <Box className={classes.sourceToolbar}>
        {selectedVars.map((item) => {
          const { icon, label, id } = varNameDetails[item];
          const Icon = icon;

          return Icon ? (
            <ButtonTooltip
              className={`${activeVarname === id ? classes.mapToolbarActiveButton : ''}`}
              title={label}
              placement="bottom"
              key={`sourceToolbar-${label}`}
            >
              <IconButton
                onClick={() => {
                  dispatch(setActiveMarker(item));
                  dispatch(setHighlightedItem({ id: '' }));
                  dispatch(setClickedItem({ id: '' }));
                }}
                size="large"
              >
                <Icon />
              </IconButton>
            </ButtonTooltip>
          ) : (
            ''
          );
        })}
        <Box sx={{ display: 'inline-flex' }}>
          <SourcesMenu iconOnlyBtn helpPosition="bottom" />
        </Box>
      </Box>
    </Box>
  );
}

export default SourceToolbar;
